<template>
  <div class="jump-config">
    <div class="jump-config-header">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <div class="search-item">
            <span class="search-label">是否推广用户:</span>
            <el-select v-model="jumpConfigSearch.isPromotionUser" placeholder="请选择" clearable style="width: 100%">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <div class="search-item">
            <span class="search-label">广告系列:</span>
            <el-input
              v-model="jumpConfigSearch.campaign"
              placeholder="请输入广告系列"
              clearable
              style="width: 100%"
            />
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <div class="search-item">
            <span class="search-label">场景:</span>
            <el-select v-model="jumpConfigSearch.scene" placeholder="请选择" clearable filterable style="width: 100%">
              <el-option
                v-for="item in sceneOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <div class="search-item">
            <span class="search-label">是否有效:</span>
            <el-select v-model="jumpConfigSearch.valid" placeholder="请选择" clearable style="width: 100%">
              <el-option label="有效" :value="1"></el-option>
              <el-option label="无效" :value="0"></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="6">
          <div class="search-item search-buttons">
            <el-button type="primary" @click="getJumpConfigList">查询</el-button>
            <el-button type="success" @click="showJumpConfigForm(false)">新增</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="jumpConfigTable" border style="width: 100%; margin-top: 20px" max-height="500">
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="isPromotionUser" label="是否推广用户" width="120">
        <template slot-scope="scope">
          {{ scope.row.isPromotionUser === 1 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column prop="campaign" label="广告系列" width="200"></el-table-column>
      <el-table-column prop="scene" label="场景" width="150">
        <template slot-scope="scope">
          {{ getSceneName(scope.row.scene) }}
        </template>
      </el-table-column>
      <el-table-column prop="jumpType" label="跳转类型" width="150">
        <template slot-scope="scope">
          {{ scope.row.jumpType === 1 ? "直播间（随机前十）" : scope.row.jumpType === 2 ? "语聊房（随机前十）" : "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="gameParams" label="游戏运营参数" width="200"></el-table-column>
      <el-table-column prop="gameBannerIcon" label="游戏横幅图标" width="150">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.gameBannerIcon"
            style="width: 50px; height: 50px"
            :src="scope.row.gameBannerIcon"
            :preview-src-list="[scope.row.gameBannerIcon]"
          >
          </el-image>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="valid" label="是否有效" width="100">
        <template slot-scope="scope">
          {{ scope.row.valid === 1 ? "有效" : "无效" }}
        </template>
      </el-table-column>
      <el-table-column prop="ctime" label="创建时间" width="180">
        <template slot-scope="scope">
          {{ scope.row.ctime ? dateFormat(scope.row.ctime * 1000) : "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="mtime" label="修改时间" width="180">
        <template slot-scope="scope">
          {{ scope.row.mtime ? dateFormat(scope.row.mtime * 1000) : "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="creator" label="创建人" width="120"></el-table-column>
      <el-table-column prop="operator" label="操作人" width="120"></el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="showJumpConfigForm(true, scope.row)">编辑</el-button>
          <el-button 
            :type="scope.row.valid === 1 ? 'danger' : 'success'" 
            size="mini" 
            @click="handleChangeJumpConfigValid(scope.row)"
          >
            {{ scope.row.valid === 1 ? "设为无效" : "设为有效" }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-wrapper" v-if="jumpConfigPagination.total > 0">
      <el-pagination
        @size-change="handleJumpConfigSizeChange"
        @current-change="handleJumpConfigCurrentChange"
        :current-page="jumpConfigPagination.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="jumpConfigPagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="jumpConfigPagination.total"
      >
      </el-pagination>
    </div>

    <!-- 签到跳转配置表单弹窗 -->
    <el-dialog
      :title="jumpConfigForm.isEdit ? '编辑签到跳转配置' : '新增签到跳转配置'"
      :visible.sync="jumpConfigForm.visible"
      width="50%"
      :before-close="handleJumpConfigFormClose"
    >
      <el-form ref="jumpConfigFormRef" :model="jumpConfigForm.data" label-width="120px">
        <el-form-item label="是否推广用户:">
          <el-radio-group v-model="jumpConfigForm.data.isPromotionUser">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="广告系列:" v-if="jumpConfigForm.data.isPromotionUser === 1">
          <el-input
            v-model="jumpConfigForm.data.campaign"
            placeholder="请输入广告系列"
            style="width: 300px"
          />
        </el-form-item>
        <el-form-item label="场景:">
          <el-select 
            v-model="jumpConfigForm.data.scene" 
            placeholder="请选择" 
            style="width: 300px"
            :disabled="jumpConfigForm.isEdit"
          >
            <el-option
              v-for="item in sceneOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跳转类型:">
          <el-select v-model="jumpConfigForm.data.jumpType" placeholder="请选择" style="width: 300px">
            <el-option label="直播间（随机前十）" :value="1"></el-option>
            <el-option label="语聊房（随机前十）" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="游戏运营参数:">
          <el-input
            v-model="jumpConfigForm.data.gameParams"
            placeholder="请输入游戏运营参数"
            style="width: 300px"
          />
        </el-form-item>
        <el-form-item label="游戏横幅图标:">
          <UploadSingleImg 
            v-model="jumpConfigForm.data.gameBannerIcon" 
            :on-upload="uploadFile"
          />
        </el-form-item>
        <el-form-item label="是否有效:">
          <el-radio-group v-model="jumpConfigForm.data.valid">
            <el-radio :label="1">有效</el-radio>
            <el-radio :label="0">无效</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="handleJumpConfigFormClose">取消</el-button>
        <el-button type="primary" @click="submitJumpConfigForm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getCheckInJumpList,
  addCheckInJump,
  updateCheckInJump,
  changeCheckInJumpValid,
  getCheckInJumpSceneConstant,
} from "@/api/rewardConfigRequest.js";
import UploadSingleImg from '@/components/UploadSingleImg/UploadSingleImg';

export default {
  name: "JumpConfig",
  components: {
    UploadSingleImg,
  },
  data() {
    return {
      jumpConfigSearch: {
        isPromotionUser: null,
        campaign: "",
        scene: null,
        valid: null,
      },
      sceneOptions: [],
      jumpConfigTable: [],
      jumpConfigPagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      jumpConfigForm: {
        visible: false,
        isEdit: false,
        data: {
          id: null,
          isPromotionUser: 0,
          campaign: "",
          scene: null,
          jumpType: 1,
          gameParams: "",
          gameBannerIcon: "",
          valid: 1,
          operator: "",
        },
      },
    };
  },
  mounted() {
    this.getSceneConstant();
    this.getJumpConfigList();
  },
  methods: {
    async getSceneConstant() {
      const res = await getCheckInJumpSceneConstant();
      if (res.code === 0 || res.code === 200) {
        this.sceneOptions = res.data || [];
      } else {
        this.$message.error(res.message || "获取场景常量失败");
      }
    },
    getSceneName(value) {
      if (value === null || value === undefined) return "-";
      const scene = this.sceneOptions.find(item => item.value === value);
      return scene ? scene.name : value;
    },
    async uploadFile(file) {
      const formdata = new FormData();
      // UploadSingleImg 传递的是 File 对象，直接使用 file
      // 如果是 el-upload 组件传递的，可能需要使用 file.raw
      const fileToUpload = file.raw || file;
      formdata.append('file', fileToUpload);
      formdata.append('cover', 0);
      formdata.append('dir', 'gameBannerIcon/');
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formdata
      );
      if (res.code !== 0) {
        return { code: res.code, msg: res.msg || '文件上传失败请重新选择文件上传' };
      }
      return { code: res.code, url: res.data };
    },
    dateFormat(input, pattern = "") {
      // 在参数列表中 通过 pattern="" 来指定形参默认值，防止报错
      var dt = new Date(input);
      // 获取年月日
      var y = dt.getFullYear();
      var m = (dt.getMonth() + 1).toString().padStart(2, "0");
      var d = dt.getDate().toString().padStart(2, "0");
      // 如果 传递进来的字符串类型，转为小写之后，等于 yyyy-mm-dd，那么就返回 年-月-日
      // 否则，就返回  年-月-日 时：分：秒
      if (pattern.toLowerCase() === "yyyy-mm-dd") {
        return `${y}-${m}-${d}`;
      } else {
        // 获取时分秒
        var hh = dt.getHours().toString().padStart(2, "0");
        var mm = dt.getMinutes().toString().padStart(2, "0");
        var ss = dt.getSeconds().toString().padStart(2, "0");
        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
      }
    },
    async getJumpConfigList() {
      const params = {
        page: this.jumpConfigPagination.page,
        pageSize: this.jumpConfigPagination.pageSize,
      };
      if (this.jumpConfigSearch.isPromotionUser !== null) {
        params.isPromotionUser = this.jumpConfigSearch.isPromotionUser;
      }
      if (this.jumpConfigSearch.campaign) {
        params.campaign = this.jumpConfigSearch.campaign;
      }
      if (this.jumpConfigSearch.scene !== null && this.jumpConfigSearch.scene !== undefined) {
        params.scene = this.jumpConfigSearch.scene;
      }
      if (this.jumpConfigSearch.valid !== null) {
        params.valid = this.jumpConfigSearch.valid;
      }
      const res = await getCheckInJumpList(params);
      if (res.code === 0 || res.code === 200) {
        this.jumpConfigTable = res.data.data || [];
        this.jumpConfigPagination.total = res.data.total || 0;
      } else {
        this.$message.error(res.message || "查询失败");
      }
    },
    showJumpConfigForm(isEdit, row) {
      this.jumpConfigForm.visible = true;
      this.jumpConfigForm.isEdit = isEdit;
      this.$nextTick(() => {
        if (isEdit && row) {
          this.$set(this.jumpConfigForm.data, "id", row.id);
          this.$set(this.jumpConfigForm.data, "isPromotionUser", Number(row.isPromotionUser) || 0);
          this.$set(this.jumpConfigForm.data, "campaign", row.campaign || "");
          this.$set(this.jumpConfigForm.data, "scene", row.scene);
          this.$set(this.jumpConfigForm.data, "jumpType", row.jumpType);
          this.$set(this.jumpConfigForm.data, "gameParams", row.gameParams || "");
          this.$set(this.jumpConfigForm.data, "gameBannerIcon", row.gameBannerIcon || "");
          this.$set(this.jumpConfigForm.data, "valid", Number(row.valid) || 1);
          this.$set(this.jumpConfigForm.data, "operator", this.$store.getters.username || "");
        } else {
          this.$set(this.jumpConfigForm.data, "id", null);
          this.$set(this.jumpConfigForm.data, "isPromotionUser", 0);
          this.$set(this.jumpConfigForm.data, "campaign", "");
          this.$set(this.jumpConfigForm.data, "scene", null);
          this.$set(this.jumpConfigForm.data, "jumpType", 1);
          this.$set(this.jumpConfigForm.data, "gameParams", "");
          this.$set(this.jumpConfigForm.data, "gameBannerIcon", "");
          this.$set(this.jumpConfigForm.data, "valid", 1);
          this.$set(this.jumpConfigForm.data, "operator", this.$store.getters.username || "");
        }
      });
    },
    async submitJumpConfigForm() {
      const formData = { ...this.jumpConfigForm.data };
      if (!formData.operator) {
        formData.operator = this.$store.getters.username || "";
      }
      let res;
      if (this.jumpConfigForm.isEdit) {
        res = await updateCheckInJump(formData);
      } else {
        res = await addCheckInJump(formData);
      }
      if (res.code === 0 || res.code === 200) {
        this.$message.success(res.message || "操作成功");
        this.handleJumpConfigFormClose();
        this.getJumpConfigList();
      } else {
        this.$message.error(res.message || "操作失败");
      }
    },
    async handleChangeJumpConfigValid(row) {
      const newValid = row.valid === 1 ? 0 : 1;
      const res = await changeCheckInJumpValid({
        id: row.id,
        valid: newValid,
        operator: this.$store.getters.username || "",
      });
      if (res.code === 0 || res.code === 200) {
        this.$message.success(res.message || "操作成功");
        this.getJumpConfigList();
      } else {
        this.$message.error(res.message || "操作失败");
      }
    },
    handleJumpConfigFormClose() {
      this.jumpConfigForm.visible = false;
      this.jumpConfigForm.isEdit = false;
      this.jumpConfigForm.data = {
        id: null,
        isPromotionUser: 0,
        campaign: "",
        scene: null,
        jumpType: 1,
        gameParams: "",
        gameBannerIcon: "",
        valid: 1,
        operator: "",
      };
    },
    handleJumpConfigSizeChange(val) {
      this.jumpConfigPagination.pageSize = val;
      this.jumpConfigPagination.page = 1;
      this.getJumpConfigList();
    },
    handleJumpConfigCurrentChange(val) {
      this.jumpConfigPagination.page = val;
      this.getJumpConfigList();
    },
  },
};
</script>
<style scoped lang="scss">
.jump-config {
  .jump-config-header {
    margin-bottom: 20px;
    
    .search-item {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      
      .search-label {
        margin-right: 10px;
        white-space: nowrap;
        flex-shrink: 0;
      }
      
      &.search-buttons {
        justify-content: flex-start;
        flex-wrap: wrap;
        gap: 10px;
        
        .el-button {
          margin-right: 10px;
          margin-bottom: 0;
        }
      }
    }
    
    @media (max-width: 768px) {
      .search-item {
        flex-direction: column;
        align-items: flex-start;
        
        .search-label {
          margin-bottom: 8px;
          margin-right: 0;
        }
        
        .el-select,
        .el-input {
          width: 100% !important;
        }
      }
      
      .search-buttons {
        width: 100%;
        
        .el-button {
          width: 100%;
          margin-right: 0;
          margin-bottom: 10px;
        }
      }
    }
  }

  .pagination-wrapper {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    
    @media (max-width: 768px) {
      justify-content: center;
      
      .el-pagination {
        .el-pagination__sizes,
        .el-pagination__jump {
          display: none;
        }
      }
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
  }
}
</style>

